import SpiceTeamComponent from "../../components/about/spice-team";

const SpiceTeamPage = () => <SpiceTeamComponent />

export default SpiceTeamPage;